import {
  AutomationDashboardSummaryMock,
  VolumeByCategoryMock,
} from '../charts/chart-types';
import {
  VolumeByTypeChartProps,
  VolumeByTypeRow,
} from './volume-by-type-chart';

const toRow = (v: VolumeByCategoryMock): VolumeByTypeRow => ({
  category: v.category,
  automated: v.automated ?? 0,
  manual: v.manual ?? 0,
  total: v.total ?? (v.automated ?? 0) + (v.manual ?? 0),
});

export interface ToVolumeByTypeChartOptions {
  /** Clip to the top N rows after the argus `total DESC` sort. */
  maxRows?: number;
  ariaLabel?: string;
}

/**
 * Map an `/api/automation-dashboard/summary` response into
 * `<VolumeByTypeChart>` props. Argus already returns the array in
 * `total DESC` order so this is essentially an identity over `volume_by_category`.
 */
export const toVolumeByTypeChartProps = (
  response: AutomationDashboardSummaryMock,
  options: ToVolumeByTypeChartOptions = {},
): VolumeByTypeChartProps => ({
  rows: (response.data.volume_by_category ?? []).map(toRow),
  maxRows: options.maxRows,
  ariaLabel: options.ariaLabel ?? 'Volume by case type',
});
